<template>
    <div>
        <div id="thediv" ref="thediv" @mouseover="clearFdAd" @mouseout="starFdAd" class="thediv" v-if="pause">
            <div style="position:relative">
                <img class="close-btn" src="../../assets/jdprotal/close_pic.png" alt="" @click="onClose">
            </div>
            <img :src="item.imgUrl" alt="" v-for="(item,index) in imgUrl" :key="index" :style="'display:block;width:'+item.imgWidth+'px;height:'+item.imgHeight+'px'" @click="toUrl(item)">
        </div>
    </div>
</template>

<script>
var interval
export default {
    props: {
        imgUrl: {
            type: Array,
            default: () => [],
        },
        linkUrl: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            xPos:100,
            yPos:100,
            step:1,
            delay:8,
            height:0,
            Hoffset:0,
            Woffset:0,
            yon:0,
            xon:0,
            pause:false,
        };
    },
    methods: {
        onClose(){
            this.pause = false
            clearInterval(interval)
        },
        toUrl(item){
            if(item.url!='#'){
                let a = document.createElement('a')
                a.setAttribute('target','view_window')
                a.href = item.url
                a.click()
            }
        },
        changePos(){
            let width=document.documentElement.clientWidth;
            let height=document.documentElement.clientHeight;
            this.Hoffset=this.$refs.thediv.offsetHeight;
            this.Woffset=this.$refs.thediv.offsetWidth;
            this.$refs.thediv.style.left=(this.xPos+document.body.scrollLeft+document.documentElement.scrollLeft)+"px";
            this.$refs.thediv.style.top=(this.yPos+document.body.scrollTop+document.documentElement.scrollTop)+"px";
            if(this.yon)
            {
                this.yPos=this.yPos+this.step;
            }
            else
            {
                this.yPos=this.yPos-this.step;
            }
            if(this.yPos<0)
            {
                this.yon=1;
                this.yPos=0;
            }
            if(this.yPos>=(height-this.Hoffset))
            {
                this.yon=0;
                this.yPos=(height - this.Hoffset);
            }
            if(this.xon)
            {
                this.xPos=this.xPos + this.step;
            }
            else
            {
                this.xPos=this.xPos - this.step;
            }
            if(this.xPos < 0)
            {
                this.xon = 1;
                this.xPos = 0;
            }
            if(this.xPos >= (width - this.Woffset))
            {
                this.xon = 0;
                this.xPos = (width - this.Woffset);
            }
        },
        clearFdAd(){
            clearInterval(interval)
        },
        starFdAd(){
            interval=setInterval(this.changePos,15)
        },
    },
    mounted() {

    },
    watch:{
        imgUrl:function(){
            if(this.imgUrl.length){
                this.pause = true
            }
            if(this.pause){
                this.$nextTick(() => {
                    interval=setInterval(this.changePos,15)
                })
            }
        }
    },
    deactivated(){
        clearInterval(interval)
    }
};
</script>
<style scoped>
.thediv {
    z-index: 9999999;
    position: absolute;
    top: 100px;
    left: 0px;
    cursor: pointer;
}
.close-btn{
    position: absolute;
    top: -9px;
    right: -9px;
}
</style>
